import axios from 'axios'
// import { mapActions } from 'vuex'

import { ApiFun } from "codoon-fun";

ApiFun.initAxios(axios);

const imgUrl = "//www.codoon.com/activity/v1/api/upload/dataurl";
axios.defaults.baseURL = "//www.codoon.com"; //TODO: 请配置你的项目api baseurl

// Add a response interceptor
axios.interceptors.request.use(
  (config: any) => {
    // Do something before request is sent
    return config;
  },
  function (error: any) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: any) => {
    return response.data;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

// 上传base64图片
export const upDataImg = (params: any) => {
  return axios.post(imgUrl, params);
};

export default axios;
